import { updateToken } from '@/config/token';
export default {
    components: {
        changePassword: () => import('./changePassword.vue'),
        changeEmail: () => import('./changeEmail.vue'),
    },
    data() {
        return {
            activeUpdate: false,
            editFullname: false,
            vloading: false,
            updatEmail: false,
            validate: {
                identity: '',
                loginname: '',
                phone: '',
            },
            fullname: '',
            loginname: '',
            statistical: {},
            productNumber: 0,
            statusStatistical: false,
            listCity: [],
            unread: 0
        }
    },
    watch: {
        user(val) {
            if(!this.statusStatistical) {
                this.getStatistical();
            }
        },
    },
    created() {
        if(this.user.id) {
            this.getStatistical();
        };
        this.getCity();
        this.unreadMessage();
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        money(){
            return this.$store.state.money;
        }
    },
    methods: {
        async getStatistical() {
            await apiGet('/v2/profile/statistical_profile').then(res => {
                this.statistical = res.data;
            }),
            // await apiGet('/v2/products/total_estore_product?iUse='+ this.user.id).then(res => {
            //     if(res.data != null) {
            //         this.productNumber = res.data.count;
            //     }
            // })
            this.statusStatistical = true;
        },
        async getCity() {
            await apiGet('/v2/country').then(res => {
                this.listCity = res;
            })
        },
        async unreadMessage() {
            await apiGet('/v2/message/unread').then(res => {
                this.unread = res.data;
            })
        },
        async changeProfile() {
            this.vloading = true;
            let form = {};
            form.birthday = this.user.birthday;
            form.gender = this.user.gender;
            form.identity = this.user.identity;
            form.tax_code = this.user.tax_code;
            form.address = this.user.address;
            form.company = this.user.company;
            form.phone = this.user.phone;
            form.website = this.user.website;
            form.province = this.user.city.id;
            await apiPut('/v2/profile', form).then(res => {
                this.$message({
                    message: 'Cập nhật thông tin thành công',
                    type: 'success',
                    center: true,
                });
                this.validate = {};
                this.vloading = false;
                updateToken(res.data.token.access_token, res.data.token.exp_at);
            }).catch(err => {
                if(err.status == 422) {
                    this.$message({
                        message: 'Cập nhật thông tin không thành công',
                        type: 'error',
                        center: true,
                    });
                    this.validate = err.data;
                }
                this.vloading = false;
            })
        },
        cancelName() {
            this.editFullname = false;
        },
        editName() {
            this.editFullname = true;
            this.fullname = this.user.name;
        },
        async confirmName() {
            this.vloading = true;
            await apiPut('/v2/profile', {
                name: this.fullname
            }).then(res => {
                if(res.success == 1) {
                    this.$message({
                        message: res.message,
                        type: 'success',
                        center: true,
                    });
                }
                this.user.name = res.data.user.name;
                this.editFullname = false;
                this.vloading = false;
                updateToken(res.data.token.access_token, res.data.token.exp_at);
            }).catch(err => {
                if(err.status == 422) {
                    this.$message({
                        message: 'Cập nhật thông tin không thành công',
                        type: 'error',
                        center: true,
                    });
                }
                this.vloading = false;
            })
        },
        async loginName() {
            this.vloading = true;
            await apiPut('/v2/profile', {
                loginname: this.loginname
            }).then(res => {
                this.$message({
                    message: 'Thêm tên đăng nhập thành công',
                    type: 'success',
                    center: true,
                });
                this.user.login_name = res.data.user.login_name;
                this.vloading = false;
                updateToken(res.data.token.access_token, res.data.token.exp_at);
            }).catch(err => {
                if(err.status == 422) {
                    this.$message({
                        message: 'Thêm tên đăng nhập không thành công',
                        type: 'error',
                        center: true,
                    });
                    this.validate.loginname = err.data.loginname;
                }
                this.vloading = false;
            })
        },
        uploadImg() {
            let input = this.$el.querySelector('.input-upload');
            input.click();
        },
        async postImage(e){
            let form;
            let image = e.target.files[0];
            this.vloading = true;
            if (image.type == 'image/jpeg' || image.type == 'image/png' || image.type == 'image/jpg'){
                form = new FormData();
                form.append('files', image);
                await apiPost(`https://cdnvg.scandict.com/upload.php`, form).then(res => {
                    let data = res[0];
                    if(data.success == 1){
                        apiPut('/v2/profile', {
                            image: data.filename
                        }).then(res => {
                            this.vloading = false;
                            this.$message({
                                message: 'Thay đổi ảnh đại diện thành công',
                                type: 'success',
                                center: true,
                            });
                            this.user.avatar.medium = res.data.user.avatar.medium;
                            updateToken(res.data.token.access_token, res.data.token.exp_at);
                        })
                    }else{

                        this.vloading = false;
                        this.$message({
                            message: `Upload ảnh ${image.name} bị lỗi`,
                            type: 'error',
                            center: true,
                        });
                    }
                }).catch(err => {
                    this.vloading = false;
                    this.$message({
                        type: 'error',
                        message: 'Lỗi hệ thống',
                        center: true,
                    });
                })
            } else {

                this.vloading = false;
                this.$message({
                    message: `Định dạng ảnh không hợp lệ.<br>Vui lòng chọn lại ảnh`,
                    type: 'error',
                    center: true,

                });
            }
        },
        payPoint() {
            location.href = "https://vatgia.com/nap-tien.html";
        },
        openBooth() {
            if(this.user.supplier == 0) {
                window.open('https://vatgia.com/dang-ky-mo-gian-hang.html', '_blank');
            } else {
                if(this.user.verified == 0) {
                    window.open('https://vatgia.com/home/estore_package.php?pagetype=register', '_blank');
                } else {
                    window.open('https://vatgia.com/home/estore_package.php?iframe=0', '_blank');
                }
            }
        }
    }
}
